import { useAdaChatBotContext } from './context';

export const useOpenAdaChat = () => {
    const { start, isStarted, isChatButtonHidden, showChatButton } = useAdaChatBotContext();
    return async () => {
        if (!isStarted) {
            await start();
        } else if (isChatButtonHidden) {
            showChatButton();
        }
    };
};
